import React from "react";
import {connect} from "react-redux";
import MyTheme from "../../Theme/Theme";
import {Platform, StyleSheet, Text, TouchableOpacity, View} from "react-native";

class KeyboardNumber extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        const style = StyleSheet.create({
            container :{
                marginTop:50,
                alignItems:"center",
                justifyContent:"center",
                display:"flex",
                height:50,
            },

            number : {
                fontSize:24,
                textAlign:"center",
                fontFamily:this.props.theme.fonts.text,
                color : this.props.theme.colors.primary.blue1.value,
            },


        });
        return (<TouchableOpacity style={{width:"33%"}}  onPress={this.props.onPress}><View style={style.container}><Text style={style.number}>{this.props.number}</Text></View></TouchableOpacity>);
    }
}


const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(KeyboardNumber);
